import React, { Component } from "react";
import Navigator from "./navigator/Navigator";

export default class App extends Component {
  render() {
    return <Navigator />;
  }
}
